export const formatPhone = (val?: string): string => {
  if (!val) return ''
  const nums = `${val}`.replace(/\D/g, '')
  const found = nums.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (!found) return ''
  return `${found[1] ? '+1 ' : ''}(${found[2]}) ${found[3]}-${found[4]}`
}
